<div class="display-flex-with-align-center-and-justify-center">
  <mat-card
    class="forgot-password-card display-flex-with-align-center-and-justify-center">
    <mat-card-header class="header-holder">
      <img
        priority
        ngSrc="assets/talentmarket.logo.svg"
        routerLink="/home"
        alt="talentmarket."
        class="logo-card cursor-pointer"
        height="100"
        width="250" />
    </mat-card-header>

    <mat-card-content>
      <!-- Prije slanja -->
      <div *ngIf="!emailSent" class="form-holder">
        <h2>{{ 'auth.forgotPassword.title' | translate }}</h2>
        <p class="description">
          {{ 'auth.forgotPassword.description' | translate }}
        </p>

        <form (ngSubmit)="onSubmit()">
          <mat-form-field appearance="fill" class="width-full">
            <mat-label>{{ 'auth.forgotPassword.emailLabel' | translate }}</mat-label>
            <input
              matInput
              type="email"
              [(ngModel)]="email"
              name="email"
              [placeholder]="'auth.forgotPassword.emailPlaceholder' | translate"
              required
              autocomplete="username" />
          </mat-form-field>

          <button
            mat-raised-button
            color="primary"
            type="submit"
            class="submit-btn"
            [disabled]="loading || !email">
            {{
              loading
                ? ('auth.forgotPassword.sending' | translate)
                : ('auth.forgotPassword.sendButton' | translate)
            }}
          </button>
        </form>

        <div class="back-to-login">
          <a routerLink="/signin">{{ 'auth.forgotPassword.backToLogin' | translate }}</a>
        </div>
      </div>

      <!-- Nakon slanja -->
      <div *ngIf="emailSent" class="success-message">
        <mat-icon class="success-icon">check_circle</mat-icon>
        <h2>{{ 'auth.forgotPassword.successTitle' | translate }}</h2>
        <p>{{ 'auth.forgotPassword.successMessage' | translate }}</p>
        <p class="small-text">
          {{ 'auth.forgotPassword.checkSpam' | translate }}
        </p>

        <div class="back-to-login">
          <a routerLink="/signin">
            <button mat-raised-button color="primary">
              {{ 'auth.forgotPassword.backToLogin' | translate }}
            </button>
          </a>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
